import React from 'react';

/* ── Iconos de marca RedMobility (set móvil/tablet) ─────────────────
   Basados en el set oficial "ICONOS REDMOBILITY".
   Cada icono tiene dos variantes:
     · outline  → estado inactivo
     · filled   → estado activo
   Heredan el color con currentColor y escalan con la prop size.
──────────────────────────────────────────────────────────────────── */

function Svg({ children, size = 24, className = '', filled = false, strokeWidth = 2 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      fill={filled ? 'currentColor' : 'none'}
      stroke={filled ? 'none' : 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

/* Inicio — casa */
export function HomeIcon({ filled = false, ...p }) {
  return filled ? (
    <Svg filled {...p}>
      <path d="M11.06 2.69a1.5 1.5 0 0 1 1.88 0l7.5 6.02c.35.29.56.72.56 1.17V19.5A1.5 1.5 0 0 1 19.5 21h-4a.75.75 0 0 1-.75-.75V15.5a1.5 1.5 0 0 0-1.5-1.5h-2.5a1.5 1.5 0 0 0-1.5 1.5v4.75A.75.75 0 0 1 8.5 21h-4A1.5 1.5 0 0 1 3 19.5V9.88c0-.45.21-.88.56-1.17z" />
    </Svg>
  ) : (
    <Svg {...p}>
      <path d="M3.5 10.2 11.3 3.4a1.1 1.1 0 0 1 1.4 0l7.8 6.8" />
      <path d="M5 9v10.5a1 1 0 0 0 1 1h3.5V15a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5.5H18a1 1 0 0 0 1-1V9" />
    </Svg>
  );
}

/* Explorar — lupa */
export function SearchIcon({ filled = false, ...p }) {
  return filled ? (
    <Svg {...p} filled={false} strokeWidth={3}>
      <circle cx="10.5" cy="10.5" r="6.5" />
      <path d="m20.5 20.5-4.6-4.6" />
    </Svg>
  ) : (
    <Svg {...p}>
      <circle cx="10.5" cy="10.5" r="6.5" />
      <path d="m20.5 20.5-4.6-4.6" />
    </Svg>
  );
}

/* Ingresar / Perfil — persona */
export function UserIcon({ filled = false, ...p }) {
  return filled ? (
    <Svg filled {...p}>
      <circle cx="12" cy="8" r="4.2" />
      <path d="M4 19.6C4 16 7.6 13.6 12 13.6s8 2.4 8 6c0 .77-.63 1.4-1.4 1.4H5.4C4.63 21 4 20.37 4 19.6Z" />
    </Svg>
  ) : (
    <Svg {...p}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4.5 20c0-3.6 3.36-6 7.5-6s7.5 2.4 7.5 6" />
    </Svg>
  );
}

/* Registro — documento con lápiz */
export function RegisterIcon({ filled = false, ...p }) {
  return filled ? (
    <Svg filled {...p}>
      <path d="M5 3.5h7.2L17 8.3V20a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 5 20zM7.5 9.25h5a.75.75 0 0 0 0-1.5h-5a.75.75 0 0 0 0 1.5m0 3h5a.75.75 0 0 0 0-1.5h-5a.75.75 0 0 0 0 1.5m0 3h3a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 0 0 1.5" fillRule="evenodd" clipRule="evenodd" />
      <path d="m18.6 12.1 1.3 1.3a1 1 0 0 1 0 1.4l-4.1 4.1-2.3.5.5-2.3 4.1-4.1a1 1 0 0 1 1.4 0Z" />
    </Svg>
  ) : (
    <Svg {...p}>
      <path d="M12 3.5H6a1.5 1.5 0 0 0-1.5 1.5v14A1.5 1.5 0 0 0 6 20.5h8a1.5 1.5 0 0 0 1.5-1.5v-7" />
      <path d="M12 3.5 16.5 8H13a1 1 0 0 1-1-1z" />
      <path d="M7.5 11.5h4M7.5 15h3" />
      <path d="m18.7 11.3 1.3 1.3a1 1 0 0 1 0 1.4l-4.2 4.2-2.4.6.6-2.4 4.2-4.2a1 1 0 0 1 1.4 0Z" />
    </Svg>
  );
}

export const NAV_ICONS = { home: HomeIcon, search: SearchIcon, user: UserIcon, register: RegisterIcon };
